import { BaseTLDetailComponent, Component, VpnReservedService, VpnReservedFilter,AxiosResponse } from "../../../Infrastructure/CorBase/CoreBase";

	export default abstract class VpnReservedDetailBase extends BaseTLDetailComponent {

		formData = {
			id: 0,
			idVpnBaseIpRange: 0,
			idVpnBaseIpRangeText: '',
			name: '',
			description: '',
			addressText: '',
			cidr: 0
		};

		vpnReservedService: VpnReservedService = new VpnReservedService();
		returnRoute: string = "VpnReservedServiceList";

		vpnBaseList: any[] = [];

		fetchVpnBaseList() {
            let filter: VpnReservedFilter = new VpnReservedFilter();
			this.vpnReservedService.getAllBaseVpn(filter).then(res => {
				this.vpnBaseList = [];
				for (var i = 0; i < res.data.length; i++) {
					this.vpnBaseList.push({ value: res.data[i].id, text: res.data[i].addressText });
				}
			});
		}

		///hlaska o prekroceni inputu po Ctrl+V
		protected infoShortInputBase(maxLength: string): void {
			this.showAlertModalWithTitleAndContent(this.$t('global.messageInfo').toString(), this.$t('global.messageShortInput').toString() + maxLength + this.$t('global.messageShortInput2').toString());
		}
		
		protected fetchDataFromServer(): Promise<AxiosResponse<any>> {
			return this.vpnReservedService.getById(this.objectId);
		}

		protected fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
			return super.NoCall()
		}

		protected refreshItems(items: any, refreshData: any): any {
			return items;
		}

		protected processResponse(response: AxiosResponse<any>): void {
            this.formData.id = response.data.id;
         
            this.formData.name = response.data.name;
			this.formData.description = response.data.description;
			this.formData.idVpnBaseIpRange = response.data.idVpnBaseIpRange;
			this.formData.idVpnBaseIpRangeText = response.data.idVpnBaseIpRangeText;
			this.formData.addressText = response.data.addressText;
			this.formData.cidr = response.data.cidr;
        }

		protected afterCreate(response: AxiosResponse<any>): void {
			this.formData.id = response.data.id;
			this.formData.idVpnBaseIpRangeText = this.vpnBaseList.filter(c => c.value == this.formData.idVpnBaseIpRange)[0].text;
		}

		protected afterUpdate(response: AxiosResponse<any>): void {
			this.formData.idVpnBaseIpRangeText = this.vpnBaseList.filter(c => c.value == this.formData.idVpnBaseIpRange)[0].text;
		}

		doAction() {
			super.doCRUDActionWithInfoMessage(this.$t('vpnReserved.messageNew').toString(), this.$t('vpnReserved.messageEdit').toString(), this.$t('vpnReserved.messageDelete').toString());
		}

		protected updateObject(): Promise<AxiosResponse<any>> {
			return this.vpnReservedService.update(this.objectId, this.formData)
		}

		protected createObject(): Promise<AxiosResponse<any>> {
			return this.vpnReservedService.create(this.formData);
		}

		protected deleteObject(): Promise<AxiosResponse<any>> {
			return this.vpnReservedService.delete(this.objectId);
		}

		vName: boolean = true;
		vDescription: boolean = true;
		vAddress: boolean = true;
		vCidr: boolean = true;

		protected validateBase() {
			return !(this.vName
				&& this.vDescription
				&& this.vAddress
				&& this.vCidr && this.formData.idVpnBaseIpRange > 0
			//	&& this.isIPv4Address(this.formData.addressText)
			);
		}

		protected isIPv4Address(ipAddress: string): boolean {
			const ipv4Regex = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
			const match = ipAddress.match(ipv4Regex);
			if (!match) {
				return false;
			}
			// Ověření, zda každý oktet IP adresy je v rozmezí 0-255
			for (let i = 1; i <= 4; i++) {
				const octet = parseInt(match[i], 10);
				if (isNaN(octet) || octet < 0 || octet > 255) {
					return false;
				}
			}
			return true;
		}

		protected isCorrectNameBase(value: any) {
			this.vName = value;
		}

		protected isCorrectDescriptionBase(value: any) {
			this.vDescription = value;
		}

		protected isCorrectAddressBase(value: any) {
			this.vAddress = value;
		}

		protected isCorrectCidrBase(value: any) {
			this.vCidr = value;
		}
	}



